import * as actIngredientLibrary from 'actions/ingredients/library'
import {connect} from 'react-redux'
import ActionBar from './ActionBar'
import List from './List'
import {doImportItem, showModalImport, showModalErrorImport} from 'actions/uploaders'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {ContentWrapper, LeftColumnWrapper, RightColumnWrapper, PageWrapper} from 'components/wrappers/pages'
import {browserHistory} from 'react-router'
import {isDirty} from 'redux-form'
import {askConfirmAction} from 'actions/confirm-action'
import {push} from 'react-router-redux'
import NoDataAndLoading from 'components/NoDataAndLoading'
import LibraryDetail from './LibraryDetail'
import LibraryImportModal from './LibraryImportModal'
import SaveToAllOutletsModal from './SaveToAllOutletsModal'

class Library extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    if (!expired) {
      this.props.dispatch(actIngredientLibrary.pageRequest())
      browserHistory.listenBefore(location => {
        if (this.props.isDirtyLibrary && !this.props.nextAction) {
          this.props.dispatch(askConfirmAction(push(location)))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    let {showImportModal, openRightColumn, libraries} = this.props.data.ingredients.library
    let {showLoadingSpinnerPage} = this.props.data.loadingSpinner

    return (
      <PageWrapper>
        <ActionBar
          onClickImport={this._onClickImport}
          onClickExport={this._onClickExport} />
        <ContentWrapper>
          <LeftColumnWrapper openRightColumn={openRightColumn}>
            <NoDataAndLoading
              showLoadingSpinner={showLoadingSpinnerPage}
              noDataToDisplay={libraries.length === 0}
              title='No Data To Display'
              description='' />
            {libraries.length > 0 && !showLoadingSpinnerPage && <List />}
          </LeftColumnWrapper>
          <RightColumnWrapper openRightColumn={openRightColumn}>
            <LibraryDetail />
          </RightColumnWrapper>
        </ContentWrapper>
        <LibraryImportModal show={showImportModal} dispatch={this.props.dispatch} />
        <ConfirmActionModal />
        <SaveToAllOutletsModal />
      </PageWrapper>
    )
  }

  _onClickTryBtn = () => {
    this.props.dispatch(showModalImport(true))
    this.props.dispatch(showModalErrorImport(false, []))
  }

  _onClear = () => {
    this.props.dispatch(showModalImport(false))
    this.props.dispatch(showModalErrorImport(false, []))
    this.props.dispatch(actIngredientLibrary.showSectionUploader(false))
  }

  _onClickExport = () => {
    let {ingredients, user} = this.props.data
    let library = ingredients.library
    let prefix = 'Ingredients - '
    let {categoryId, typeInventoryId, keyword} = library.filterState
    let formatCategory = categoryId
    this.props.dispatch(actIngredientLibrary.libraryExportRequest(prefix, user.email, library.outlets, formatCategory, this._formatExportbyInventoryId(typeInventoryId), keyword))
  }

  _formatExportbyInventoryId = (inventoryId) => {
    let result
    let parseInventoryId = parseInt(inventoryId)
    if (parseInventoryId) {
      if (parseInventoryId === 1) {
        result = 'low'
      } else {
        result = 'out'
      }
    } else {
      result = 'all'
    }
    return result
  }

  _onClickImport = () => {
    this.props.dispatch(actIngredientLibrary.showImportModal())
  }

  _onClickUploadButton = (file, importType) => {
    this.props.dispatch(doImportItem(file, importType))
  }
  _onClickDownloadTemplate = () => {
    let library = this.props.data.ingredients.library
    let {user} = this.props.data
    let prefix = 'Ingredients Library - '
    this.props.dispatch(actIngredientLibrary.downloadLibraryTemplate(prefix, user.email, library.outlets))
  }
}

function select (state) {
  // only fetch some state
  let ingredientState = state.ingredients
  return {
    data: {
      ingredients: {
        library: ingredientState.library
      },
      outlet: state.outlet,
      category: state.category,
      user: state.moka.user,
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired
    },
    buttons: state.buttons,
    uploaders: state.uploaders,
    nextAction: state.confirmAction.nextAction,
    isDirtyLibrary: isDirty('library')(state)
  }
}
export default connect(select)(Library)



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Library/Library.js